<template>
<v-layout row justify-center>
    <v-dialog :value="dialog" @input="reset" persistent width="45vmax">
      <v-card class="pa-3">
        <v-card-title primary-title>
        <div>
            <div class="title">{{$t('screener.magic_link.form.title')}} </div>
            <div class="py-2 subheading">{{$t('screener.magic_link.form.subtitle')}}</div>
        </div>
            <v-spacer></v-spacer>
            <v-btn
            class="mx-0"
            small
            dark
            icon
            color="grey"
            @click.native="reset()"
            >
                <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-form ref="magicLinkUserForm" onsubmit="return false;">
                <!-- Name -->
                <v-text-field
                v-model="user.name"
                id="name"
                :label="$t('screener.magic_link.form.name.lable')"
                name="name"
                :rules="[
                    rules.min_length(3),
                    rules.max_length(250),
                ]"
                color="secondary"
                type="text">
                </v-text-field>
                <!-- Email -->
                <v-text-field
                v-model="user.email"
                id="email"
                :label="$t('screener.magic_link.form.email.lable')"
                name="email"
                :rules="[
                    rules.required,
                    rules.email
                ]"
                color="secondary"
                type="text">
                </v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="grey" outline @click.native="reset()">{{$t('screener.btn.cancel')}}</v-btn>
            <v-btn color="primary" outline @click.native="login()">{{$t('screener.btn.magic_link.watch')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import rules from "@/validation";

export default {
    name:"MagicLinkUserForm",
    props:{
        dialog:{
            type:Boolean,
            defaul:false
        }
    },
    data(){
        return{
            rules,
            user:{
                name:null,
                email:null,
            }
        }
    },
    watch:{
        user:{
            deep:true,
            handler:function(){
                this.$emit("update:user",this.user)
            }
        }
    },
    methods:{
        reset() {
            this.$refs.magicLinkUserForm.reset();
            this.$emit("reset")
        },
        login(){
            this.$emit("login")
        },
        validate() {
            return this.$refs.magicLinkUserForm.validate();
        },
    }
}
</script>

<style>

</style>
